export const buildQueryFromObject = (
    obj: Record<string, string | number | Record<string, string | number> | undefined>,
    prefix?: string
): string => {
    const query = [];

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const currentKey = prefix ? prefix + '[' + key + ']' : key;
            const currentValue = obj[key] as string;

            if (currentValue === '' || currentValue === undefined) {
                continue;
            }

            query.push(
                currentValue !== null && typeof currentValue === 'object'
                    ? buildQueryFromObject(currentValue, currentKey)
                    : encodeURIComponent(currentKey) +
                          '=' +
                          encodeURIComponent(currentValue)
            );
        }
    }
    return query.join('&');
};
